import { Button } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useAlert } from "@/";
import { useDispatch, useSelector } from "react-redux";
import { savePincodes } from "../../../app/Slices";
const UpdatePincode = ({ onSubmit, setSheetOpen = () => {} }) => {
  const { alert, AlertDialog } = useAlert();
  const user = useSelector((state) => state.user.user) || {};
  const name = user?.name || "";
  console.log(name);
  const dispatch = useDispatch();
  const handleChange = (key, value) => {
    setSelectedFile((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedFile, setSelectedFile] = useState({
    pincodeFile: null,
    pincodeData: name,
  });

  const handleSubmit = async () => {
    if (!selectedFile.pincodeFile) {
      await alert("Please select a file before uploading.");
      return;
    }

    try {
      const action = await dispatch(
        savePincodes({
          file: selectedFile.pincodeFile,
          data: selectedFile.pincodeData,
        })
      );

      if (savePincodes.fulfilled.match(action)) {
        await alert("Pincodes uploaded successfully");
        setSheetOpen(false);
      } else {
        console.error("Pincode Upload Failed:", action.payload);
        await alert(action.payload || "Pincode Upload Failed");
      }
    } catch (error) {
      console.error("API Error:", error.message);
      await alert("An error occurred while uploading the pincodes.");
    }
  };

  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download Pincode sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Admin_Pincode_Servisability.csv";
              }}
            >
              Download Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated Pincode sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload Pincode Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("pincodeFile", file)}
            />
          </div>
        </div>
      </div>
      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>
        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleSubmit}
        >
          Upload
        </Button>
      </div>
      <AlertDialog />
    </div>
  );
};

export default UpdatePincode;
